import Header from "../../components/layout/Header";
import Footer from "../../components/layout/Footer";
import SEO from "../../components/SEO";
import { SITE_URL } from "../../config/site";
import "./LegalPages.css";

export default function TermsPage() {
  return (
    <>
      <SEO
        title="Términos y condiciones | Imalandia"
        description="Consulta las condiciones de compra, producción, envío y uso de productos personalizados en Imalandia."
        canonical={`${SITE_URL}/terminos`}
      />

      <Header />

      <main className="legal-page">
        <div className="legal-container">
          <p className="legal-eyebrow">TERMINOS</p>

          <h1>Términos y condiciones</h1>

          <div className="legal-content">

            <h3>1. Objeto</h3>

            <p>
              Estos Términos y Condiciones regulan la compra de productos en la
              tienda online de Imalandia. Al realizar un pedido el cliente
              acepta estas condiciones.
            </p>

            <h3>2. Productos personalizados</h3>

            <p>
              Los productos ofrecidos son principalmente personalizados y
              regalos a medida. El cliente es responsable de revisar y confirmar
              correctamente textos, nombres, fechas, imágenes y datos antes de
              pagar.
            </p>

            <h3>3. Material aportado por el cliente</h3>

            <p>
              Si el cliente envía imágenes, logos o textos, declara tener
              derecho a utilizarlos y autoriza su uso para la elaboración del
              producto. Imalandia no se responsabiliza por reclamaciones de
              terceros derivadas del contenido aportado por el cliente.
            </p>

            <h3>4. Precios y pagos</h3>

            <p>
              Los precios se muestran en euros e incluyen los impuestos
              aplicables, salvo indicación distinta. El pedido no se inicia
              hasta que el pago esté confirmado.
            </p>

            <h3>5. Producción y plazos</h3>

            <p>
              Los pedidos personalizados requieren tiempo de preparación. Los
              plazos de entrega son orientativos y pueden variar según la
              personalización y la logística.
            </p>

            <h3>6. Envíos</h3>

            <p>
              Los pedidos se envían a la dirección indicada por el cliente.
              Imalandia no se responsabiliza de retrasos por causas ajenas
              (transporte, dirección incorrecta o incompleta, etc.).
            </p>

            <h3>7. Cancelaciones</h3>

            <p>
              Los pedidos personalizados solo pueden cancelarse antes de iniciar
              la producción. Una vez comenzada no se garantiza la cancelación.
            </p>

            <h3>8. Devoluciones y desistimiento</h3>

            <p>
              Salvo que la normativa aplicable disponga lo contrario, el cliente
              tiene un plazo de 7 días para desistir en productos no
              personalizados.
            </p>

            <p>
              En productos personalizados o confeccionados según las
              especificaciones del cliente, el desistimiento no aplica (salvo
              defecto de fabricación o error imputable a Imalandia).
            </p>

            <h3>9. Incidencias y productos defectuosos</h3>

            <p>
              Si el producto llega dañado, defectuoso o distinto a lo
              solicitado, el cliente debe comunicarlo a pedidos@imalandia.com en
              un plazo máximo de 5 días, aportando el número de pedido y
              fotografías.
            </p>

            <h3>10. Uso de cookies</h3>

            <p>
              Este sitio web utiliza cookies para mejorar la experiencia y, si
              aplica, para análisis y preferencias. El usuario puede gestionar
              su consentimiento desde el banner de cookies y/o la Política de
              Cookies.
            </p>

            <h3>11. Protección de datos</h3>

            <p>
              Los datos personales se tratan para gestionar pedidos, atención al
              cliente y obligaciones legales, conforme a la Política de
              Privacidad.
            </p>

            <h3>12. Modificaciones</h3>

            <p>
              Imalandia puede actualizar estos Términos y Condiciones. Los
              cambios no afectan a pedidos ya confirmados.
            </p>

            <h3>13. Legislación aplicable</h3>

            <p>
              Estos Términos se rigen por la legislación vigente en España. En
              caso de controversia, serán competentes los juzgados y tribunales
              correspondientes.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}
